/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SetDefaultFacilityPhysicianRequestPhysicianId } from './SetDefaultFacilityPhysicianRequestPhysicianId';
import {
    SetDefaultFacilityPhysicianRequestPhysicianIdFromJSON,
    SetDefaultFacilityPhysicianRequestPhysicianIdFromJSONTyped,
    SetDefaultFacilityPhysicianRequestPhysicianIdToJSON,
} from './SetDefaultFacilityPhysicianRequestPhysicianId';

/**
 * 
 * @export
 * @interface SetDefaultFacilityPhysicianRequest
 */
export interface SetDefaultFacilityPhysicianRequest {
    /**
     * 
     * @type {SetDefaultFacilityPhysicianRequestPhysicianId}
     * @memberof SetDefaultFacilityPhysicianRequest
     */
    physician_id: SetDefaultFacilityPhysicianRequestPhysicianId | null;
}

/**
 * Check if a given object implements the SetDefaultFacilityPhysicianRequest interface.
 */
export function instanceOfSetDefaultFacilityPhysicianRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "physician_id" in value;

    return isInstance;
}

export function SetDefaultFacilityPhysicianRequestFromJSON(json: any): SetDefaultFacilityPhysicianRequest {
    return SetDefaultFacilityPhysicianRequestFromJSONTyped(json, false);
}

export function SetDefaultFacilityPhysicianRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultFacilityPhysicianRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'physician_id': SetDefaultFacilityPhysicianRequestPhysicianIdFromJSON(json['physician_id']),
    };
}

export function SetDefaultFacilityPhysicianRequestToJSON(value?: SetDefaultFacilityPhysicianRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'physician_id': SetDefaultFacilityPhysicianRequestPhysicianIdToJSON(value.physician_id),
    };
}

